/** ------------------------------------------------------------------------- *
 * JavaScript Modules *
 * -------------------------------------------------------------------------- *
 */

import Animate from './modules/animate';
import Dropdown from './modules/dropdown';
import Tables from './modules/tables';
import Toggle from './modules/toggle';
import StickyNav from './modules/sticky-nav';
import Slider from './modules/slider';
import Testimonials from './modules/testimonials'; // https://www.w3.org/WAI/tutorials/carousels/working-example/

/** -------------------- *
 * Module Initialization *
 * --------------------- *
 */

// Initialize on all pages for navigation
StickyNav.init();
Toggle.init();

// Initialize if required
if (document.querySelector(Dropdown.selector) !== null) {
    Dropdown.init();
}

// Initialize if required
if (document.querySelector(Animate.selector) !== null) {
    Animate.init();
}

// Initialize if required
if (document.querySelector(Tables.selector) !== null) {
    Tables.init();
}

// Initialize if required
if (document.querySelector(Slider.selector) !== null) {
    Slider.init();
}

if (document.querySelector('.testimonials') !== null) {
    // Initialize the testimonials slider
    Testimonials.init({
        id: 'carousel',
        slidenav: true,
        animate: true,
        startAnimated: true,
    });
}
